// API Configuration
import axios from 'axios';
import { debug } from '../utils/debugUtils';

const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  withCredentials: true,
};

// Create axios instance with interceptors
const apiClient = axios.create(API_CONFIG);

// Response interceptor to handle 401 (unauthorized) responses
apiClient.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized responses
    if (error.response?.status === 401) {
      // Only redirect if NOT already on login page (prevents infinite loop)
      if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
        debug.warn('Session expired, redirecting to login...');
        
        // Clear any stored auth data
        localStorage.removeItem('auth_token');
        sessionStorage.clear();
        
        // Redirect to login page
        window.location.href = '/';
        
        // Prevent further error handling for this request
        return new Promise(() => {}); // Never resolve to prevent error propagation
      }
    }
    
    // For all other errors, or 401s on login page, pass them through
    return Promise.reject(error);
  }
);

// Export both the config and the configured axios instance
export { apiClient };
export default API_CONFIG; 